module.exports = __webpack_public_path__ + "img/3.57e730c3.jpg";